import { render, staticRenderFns } from "./AdminVolunteersList.vue?vue&type=template&id=5ed2bc03"
import script from "./AdminVolunteersList.vue?vue&type=script&lang=js"
export * from "./AdminVolunteersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports